import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { handleZohoCallback as zohoCallbackService } from "../services/connectors.service";
import { useAlert } from "../functions/useAlert";

export function useZohoCallback() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [setAlert] = useAlert();

  useEffect(() => {
    const run = async () => {
      const code = searchParams.get("code");
      const state = searchParams.get("state");
      const error = searchParams.get("error");
      const location = searchParams.get("location");
      const accountsServer = searchParams.get("accounts-server");

      if (error) {
        setAlert(`Zoho Connection Failed: ${error}`, "error");
        setSearchParams({});
        return;
      }

      if (code && state) {
        try {
          const response: any = await zohoCallbackService({
            code,
            state,
            location,
            "accounts-server": accountsServer,
          });
          if (response.success) {
            setAlert("Zoho CRM connected successfully!", "success");
          } else {
            setAlert("Failed to connect Zoho.", "error");
          }
        } catch (err: any) {
          setAlert(err.message || "Error connecting Zoho.", "error");
        } finally {
          setSearchParams({});
        }
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);
}
